import { z } from "zod";

export const EmployeeItemSchema = z.object({
  Id: z.string(),
  Name: z.string().optional(),
  FirstName: z.string().optional(),
  DisplayName: z.string().optional(),
  LastName: z.string().optional(),
  FullName: z.string().optional(),
  AccountId: z.string().optional(),
  Phone: z.string().optional(),
  Email: z.string().optional(),
  Login: z.string().optional(),
  Title: z.string().optional(),
  Role: z.string().optional(),
  SecurityRoleName: z.string().optional(),
  Image: z.string().optional(),
});

export type EmployeeItemType = z.infer<typeof EmployeeItemSchema>;
